<!-- 
  --------------------------------------------------------------
  @time: 2023/10/26
  @author: 邻家大龙猫
  @description: "客户服务" 页面开发
  --------------------------------------------------------------
 -->

<template>
  <div class="customer_service_container">
    <!-- header -->
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>

    <!-- big title -->
    <div class="area_title">
      <h1>{{ customerServicePage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="toPath">{{ customerServicePage.title }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeTabText !== ''">{{ activeTabText }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- tab栏&tab栏内容 -->
    <div class="area_cation">
      <el-tabs
        v-model="active_tab_item"
        type="card"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          v-for="item in tab_list"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        >
          <component :is="item.component_name"></component>
          <!-- footer -->
          <div class="footer-box">
            <footer-tab></footer-tab>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- main content -->
    <div class="main-content__container" v-show="!active_tab_item || active_tab_item < 1">
      <!-- head -->
      <div class="zp_wrap main-content__head">
        <h2 class="main-content__head-title">
          {{ customerServicePage.subTitle }}
        </h2>
        <p
          class="main-content__head-text"
          v-for="(txt, idx) in main_content_text"
          :key="idx"
        >
          {{ txt }}
        </p>
      </div>

      <!-- content list -->
      <ul class="main-content__list">
        <li
          v-for="(item, idx) in main_content_list"
          :key="idx"
          class="main-content__list-item flex"
          :class="[(idx + 1) % 2 === 0 ? 'f-row-reverse' : '']"
        >
          <!-- image -->
          <div
            class="main-content__list-item__img"
            :class="[item.bg_img_class]"
          ></div>
          <!-- content body -->
          <div
            class="main-content__list-item__body flex"
            :class="[(idx + 1) % 2 === 0 ? 'f-jus-end' : '']"
          >
            <div class="flex f-column f-jus-center main-content__list-item__box">
              <!-- title -->
              <h2 class="main-content__list-item__body-title">
                <span>{{ item.title }}</span>
              </h2>
              <!-- content -->
              <div class="main-content__list-item__body-content">
                <p v-for="(txt, idx) in item.content" :key="idx">{{ txt }}</p>
              </div>
              <!-- button -->
              <div
                class="main-content__list-item__body-btn"
                @click.stop="handleBtnClick(item)"
              >
                <span>{{ item.button_text }}</span>
                <img
                  class="more_btn"
                  src="../../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- footer -->
      <div class="footer-box">
        <footer-wrap></footer-wrap>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TabContentOne from "./components/TabContentOne.vue";
import TabContentTwo from "./components/TabContentTwo.vue";
import TabContentThree from "./components/TabContentThree.vue";
import TabContentFour from "./components/TabContentFour.vue";
import TabContentFive from "./components/TabContentFive.vue";
import TabContentSix from "./components/TabContentSix.vue";

export default {
  inject: ['reload'],

  components: {
    TabContentOne,
    TabContentTwo,
    TabContentThree,
    TabContentFour,
    TabContentFive,
    TabContentSix
  },

  data() {
    return {
      active_tab_item: '',
      activeTabText: ''
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    customerServicePage() {
      return this.currentLang.config.customerServicePage;
    },
    tab_list() {
      return this.currentLang.config.customerServicePage.tab_list;
    },
    main_content_text() {
      return this.currentLang.config.customerServicePage.main_content_text;
    },
    main_content_list() {
      return this.currentLang.config.customerServicePage.main_content_list;
    },
    navbar() {
      return this.currentLang.config.navbar;
    }
  },

  created() {
    if(this.$route.query.index){
      this.active_tab_item = this.$route.query.index
      const result = this.tab_list.find(info => (info.value == this.active_tab_item))
      this.activeTabText = result ? result.label : this.activeTabText
    }
  },

  mounted() {
    this.$nextTick(() => {
      console.log('this.active_tab_item', this.active_tab_item)
    })
  },

  methods: {
    toPath(){
      this.$router.push('/customer_service')
      this.reload()
    },

    // tab_nav 按钮点击回调
    handleTabClick(event) {
      this.active_tab_item = `${Number(event.index) + 1}`;
      this.activeTabText = event.label;
      this.$router.push({
        path: '/customer_service',
        query: {
          index: this.active_tab_item
        }
      })
      this.reload()
    },

    handleBtnClick(info) {
      this.active_tab_item = `${info.value}`;
      this.activeTabText = info.title;
      this.$router.push({
        path: 'customer_service',
        query: {
          index: this.active_tab_item
        }
      })
      this.reload()
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}

.zp_wrap {
  width: 1000px;
  height: auto;
  margin: 50px auto;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .main-content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
  .main-content__head-text:nth-child(n - 1) {
    margin-bottom: 30px;
  }
}

.main-content__container {
  width: 100%;

  .main-content__list {
    width: 100%;
  }

  .main-content__list-item {
    width: 100%;
    height: 550px;
    background-color: #f5f5f5;
  }

  .main-content__list-item__img {
    width: 50%;
    height: 550px;
  }

  .main-content__list-item__img-bg1 {
    background: url("../../../assets/images1/customer_service/khfw01.jpg")
      no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
  .main-content__list-item__img-bg2 {
    background: url("../../../assets/images1/customer_service/khfw02.jpg")
      no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
  .main-content__list-item__img-bg3 {
    background: url("../../../assets/images1/customer_service/khfw03.jpg")
      no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
  .main-content__list-item__img-bg4 {
    background: url("../../../assets/images1/customer_service/khfw04.jpg")
      no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
  .main-content__list-item__img-bg5 {
    background: url("../../../assets/images1/customer_service/khfw05.jpg")
      no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
  .main-content__list-item__img-bg6 {
    background: url("../../../assets/images1/customer_service/khfw06.jpg")
      no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .main-content__list-item__body {
    width: 50%;
    // padding: 0 84px;
  }

  .main-content__list-item__box {
    width: 60%;
    margin: 0 110px;
  }

  .main-content__list-item__body-title {
    color: #003258;
    font-weight: normal;
    margin: 0 0 30px 0;
  }

  .main-content__list-item__body-content {
    min-height: 210px;
    margin: 0 0 0px 0;
    color: #777777;
    line-height: 1.8;
    text-align: justify;
    font-size: var(--text-size-bit-larger);
  }

  .main-content__list-item__body-btn {
    width: 140px;
    height: 45px;
    background: #e8363e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin: 40px 0 0 0;
    cursor: pointer;
    .more_btn {
      width: 40px;
      margin-left: 10px;
    }
  }
}

.footer-box {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home_customer_service/index.vue